import { Label } from '@talentmesh/ui/components/label';
import { Separator } from '@talentmesh/ui/components/separator';
import SkillsSelector from './SkillsSelector';
import JobAdSkillsType from '@/Models/JobAdSkillsType';
import UIStrings from '@/Utils/UIStrings';

function RequiredSkills() {
    return (
        <div className="flex flex-col gap-2.5">
            <Label>{UIStrings.SkillsRequiredToSucceed}</Label>
            <div className="border-border bg-card flex flex-col rounded-lg border">
                <SkillsSelector
                    type={JobAdSkillsType.HardSkill}
                    label={UIStrings.HardSkills}
                    placeholder={UIStrings.AddSkills}
                    tooltip={UIStrings.ThisSectionIncludesTheSkillRequiredToSucceed('hard skills')}
                />
                <Separator className="border-border" />
                <SkillsSelector
                    type={JobAdSkillsType.SoftSkill}
                    label={UIStrings.SoftSkillsPersonalityTraits}
                    placeholder={UIStrings.TypePersonalityTraits}
                    tooltip={UIStrings.ThisSectionIncludesTheSkillRequiredToSucceed(
                        'soft skills and personality traits',
                    )}
                />
            </div>
        </div>
    );
}

export default RequiredSkills;
